module.exports = "/1st/2026/packs/img_search_icon_b-4d6f9d0ad7d7242b8685d75ad196655d.png";